// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"f3575b46","221":"626eba1d","359":"da22a643","378":"653c0320","409":"d3d8bb3f","418":"7c4c7f46","464":"3d402512","522":"c658c6bc","575":"240a0a41","674":"0db06dca","681":"3680e6f0","731":"ae0655e1","860":"1a29151a","878":"d78bb16f","920":"ddb4608d"}[chunkId] + ".chunk.js";
};